const AppImages = {
    homebannerSlide01 : require('../images/home-banner-1.png'),
    homebannerSlide02 : require('../images/banner-2.jpg'),
    aboutUsRight: require('../images/about-us-home.png'),
    steelPipes: require('../images/steel-pipes.png'),
    steelPlates: require('../images/steel-plates.png'),
    projectCargo: require('../images/project-cargo.png'),
    containerVessel: require('../images/container-vessel.png'),
    dolomite: require('../images/dolomite.png'),
    dolomiteBags: require('../images/dolomite-bags.png'),
    limeStone: require('../images/limestone.png'),
    limeStoneBags: require('../images/limestone-bags.png'),
    copperSlag: require('../images/copper-slack.png'),
    fishingBoat: require('../images/fishing-boats.png'),
    explosiveMaterial: require('../images/explosion.png'),
    portDuqm: require('../images/port-duqm.png'),
    portJindaal: require('../images/port-jindaal.png'),
    roundBloom: require('../images/round-blooms.png'),
    steelRebar: require('../images/steel-rebar.png'),
    squareBillet: require('../images/sqaure-billet.png'),
    steelWires: require('../images/steel-wires.png'),
    scraps: require('../images/scrap.png'),
    bulkCargo: require('../images/bulk-cargo.png'),
    steelCoils: require('../images/steel-coils.png'),
    mapImage: require('../images/map-section.png'),
    review1: require('../images/review-1.png'),
    review2: require('../images/review-2.png'),
    review3: require('../images/review-3.png'),
    review4: require('../images/review-4.png'),
    star: require('../images/star.svg'),
    ourTeam: require('../images/ourteam-1.png'),
    ourTeam2: require('../images/ourteam-2.png'),
    ourTeam3: require('../images/ourteam-3.png'),
    ourTeam4: require('../images/ourteam-4.png'),
    aboutPageLeft: require('../images/about-page-left.png'),
    ourGoals: require('../images/ourgoals.png'),
    blog2 : require('../images/blog-2.png'),
    jindalShadeedNew :require('../images/port-images/jindal-shadeed.jpg'),
    containersNew : require('../images/port-images/containers.jpg'),
    craneSteel : require('../images/port-images/ship-loading.jpg'),
    loadingShip: require('../images/port-images/loaded-ship.jpg'),
    whyChoose: require('../images/port-images/why-choose.png'),
    aboutWhiteTower: require('../images/port-images/about-sec-2.png'),
    ourGoals: require('../images/port-images/about-us-sec3.png'),
    ceoImage: require('../images/placeholder-image-user.png'),
    chairmanImage: require('../images/chairman.jpg'),
    blogImage1: require('../images/port-images/blog-one-image.png'),
    blogImage2: require('../images/port-images/blog-two-image.png'),
    blogImage3: require('../images/port-images/blog-three-image.png'),
    aboutUsBread: require('../images/about-us-breadcrumb.png'),
    jindalLogo: require('../images/our-partners/jindal.png'),
    duqmLogo: require('../images/our-partners/duqm.png'),
    soharLogo: require('../images/our-partners/sohar.png'),
    steinwegLogo: require('../images/our-partners/steinweg.png'),
    soharSteelLogo: require('../images/our-partners/sohar-steel-logo.png'),
    
}

export default AppImages;